module.exports = __webpack_public_path__ + "static/media/P6.910e38b0.png";